/*
 * Pre-order discount: attaches the campaign code to the visitor's cart via the
 * Cart AJAX API, so it's already on the order at checkout. The code stays on the
 * cart while it's empty and applies once a qualifying product is added.
 *
 * [data-preorder-discount]              container, carries data-code
 *   [data-preorder-claim]               button/link that applies the code on click
 *   [data-preorder-claimed]             shown once the code is applied
 * data-auto-apply="true" on the container applies the code on page load.
 */
(function () {
  const STORAGE_PREFIX = 'preorder-discount:';

  function remember(code) {
    try { localStorage.setItem(STORAGE_PREFIX + code, '1'); } catch (e) {}
  }

  function wasClaimed(code) {
    try { return localStorage.getItem(STORAGE_PREFIX + code) === '1'; } catch (e) { return false; }
  }

  function applyCode(code) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const codes = (cart.discount_codes || []).map((d) => d.code);
        if (codes.some((c) => c.toUpperCase() === code.toUpperCase())) return;
        // `discount` replaces the cart's codes, so keep any the shopper already has.
        codes.push(code);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') }),
        }).then((res) => {
          if (!res.ok) throw new Error('discount apply failed: ' + res.status);
        });
      })
      .then(() => remember(code));
  }

  function markClaimed(container) {
    const claim = container.querySelector('[data-preorder-claim]');
    const claimed = container.querySelector('[data-preorder-claimed]');
    if (claim) claim.hidden = true;
    if (claimed) claimed.hidden = false;
  }

  document.querySelectorAll('[data-preorder-discount]').forEach((container) => {
    const code = container.dataset.code;
    if (!code) return;

    if (container.dataset.autoApply === 'true') {
      // Re-apply on every visit: the session cookie may have expired since last time.
      applyCode(code).then(() => markClaimed(container)).catch((err) => console.error(err));
    } else if (wasClaimed(code)) {
      markClaimed(container);
      applyCode(code).catch((err) => console.error(err));
    }

    const claim = container.querySelector('[data-preorder-claim]');
    if (!claim) return;
    claim.addEventListener('click', (event) => {
      // Without JS the link itself applies the code and redirects back.
      event.preventDefault();
      claim.setAttribute('aria-busy', 'true');
      applyCode(code)
        .then(() => markClaimed(container))
        .catch(() => { window.location.href = claim.href; });
    });
  });
})();
